var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroups(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 138,
    viewBox: "0 0 138 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "groups",
    clipPath: "url(#clip0_451_3632)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_451_3632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69 73.1136C78.3354 73.1136 86.5827 75.3472 93.2836 78.2681C99.4691 81.0172 103.364 87.2026 103.364 93.9036V103.182H34.6364V93.9608C34.6364 87.2026 38.5309 81.0172 44.7164 78.3254C51.4173 75.3472 59.6645 73.1136 69 73.1136ZM23.1818 74.5454C29.4818 74.5454 34.6364 69.3908 34.6364 63.0908C34.6364 56.7908 29.4818 51.6363 23.1818 51.6363C16.8818 51.6363 11.7273 56.7908 11.7273 63.0908C11.7273 69.3908 16.8818 74.5454 23.1818 74.5454ZM29.6536 80.8454C27.5345 80.5017 25.4155 80.2726 23.1818 80.2726C17.5118 80.2726 12.1282 81.4754 7.26 83.5945C3.02182 85.4272 0.272728 89.5508 0.272728 94.1899V103.182H26.0455V93.9608C26.0455 89.2072 27.3627 84.7399 29.6536 80.8454ZM114.818 74.5454C121.118 74.5454 126.273 69.3908 126.273 63.0908C126.273 56.7908 121.118 51.6363 114.818 51.6363C108.518 51.6363 103.364 56.7908 103.364 63.0908C103.364 69.3908 108.518 74.5454 114.818 74.5454ZM137.727 94.1899C137.727 89.5508 134.978 85.4272 130.74 83.5945C125.872 81.4754 120.488 80.2726 114.818 80.2726C112.585 80.2726 110.465 80.5017 108.346 80.8454C110.637 84.7399 111.955 89.2072 111.955 93.9608V103.182H137.727V94.1899ZM69 34.4545C78.5073 34.4545 86.1818 42.129 86.1818 51.6363C86.1818 61.1436 78.5073 68.8181 69 68.8181C59.4927 68.8181 51.8182 61.1436 51.8182 51.6363C51.8182 42.129 59.4927 34.4545 69 34.4545Z",
    fill: "#447D00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_451_3632",
    x: -2.72727,
    y: 32.4545,
    width: 143.455,
    height: 74.7273,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.321569 0 0 0 0 0.294118 0 0 0 0 0.286275 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_451_3632"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_451_3632",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_451_3632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 137.455,
    height: 137.455,
    fill: "white",
    transform: "translate(0.272728 0.0908203)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroups);
export default __webpack_public_path__ + "static/media/groups.800698fadb9b149efdf2f76610c315fd.svg";
export { ForwardRef as ReactComponent };